const ButtonText = {
    goBackToDashboard: "Back To Dashboard",
    tryAgain: "Try Again"
};

export default ButtonText;